// @ts-strict-ignore
export const extractBlogArticles = data => data?.data?.strapi?.data?.articles?.data
